import type { JSX } from 'react'

export const ApprovalsEmptyStateIllustration = (): JSX.Element => {
  return (
    <svg
      width="335"
      height="300"
      viewBox="0 0 335 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M167.809 299.223C230.135 299.223 280.764 254.269 280.764 198.697V174.355C280.764 174.079 280.54 173.855 280.264 173.855C279.988 173.856 279.764 174.08 279.764 174.355V198.697C279.764 253.61 229.696 298.223 167.809 298.223C105.9 298.222 55.8536 259.638 55.8535 198.697L55.8535 86.5352L75.1953 103.9C75.4007 104.085 75.7169 104.067 75.9014 103.862C76.0855 103.657 76.0684 103.341 75.8633 103.156L55.7461 85.0947C55.5564 84.9246 55.2691 84.9249 55.0791 85.0947L34.9033 103.155C34.6976 103.339 34.6801 103.656 34.8643 103.861C35.0484 104.067 35.3637 104.084 35.5693 103.9L54.8535 86.6377L54.8535 198.697C54.8536 260.335 105.503 299.222 167.809 299.223Z"
        fill="var(--color-illustration-border)"
      />
      <g filter="url(#filter0_d_693_25977)">
        <rect
          x="10"
          y="193"
          width="240"
          height="60"
          rx="5"
          fill="var(--color-illustration-card)"
          shapeRendering="crispEdges"
        />
        <rect
          x="10.5"
          y="193.5"
          width="239"
          height="59"
          rx="4.5"
          stroke="var(--color-illustration-border)"
          shapeRendering="crispEdges"
        />
        <rect
          x="65"
          y="213"
          width="156"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="65"
          y="227"
          width="134"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <path
          d="M39.5 208C47.5081 208 54 214.492 54 222.5C54 230.508 47.5081 237 39.5 237C31.4919 237 25 230.508 25 222.5C25 214.492 31.4919 208 39.5 208ZM45.3838 217.939C44.798 217.354 43.8485 217.354 43.2627 217.939L37.9131 223.288L36.0605 221.436C35.4748 220.85 34.5252 220.85 33.9395 221.436C33.3537 222.021 33.3537 222.971 33.9395 223.557L36.8525 226.471C37.4382 227.056 38.3878 227.056 38.9736 226.471L45.3838 220.061C45.9694 219.475 45.9694 218.525 45.3838 217.939Z"
          fill="var(--color-illustration-accent)"
          fillOpacity="0.4"
        />
      </g>
      <g filter="url(#filter1_d_693_25977)">
        <rect
          x="10"
          width="240"
          height="60"
          rx="5"
          fill="var(--color-illustration-card)"
          shapeRendering="crispEdges"
        />
        <rect
          x="10.5"
          y="0.5"
          width="239"
          height="59"
          rx="4.5"
          stroke="var(--color-illustration-border)"
          shapeRendering="crispEdges"
        />
        <rect
          x="65"
          y="20"
          width="156"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="65"
          y="34"
          width="134"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <path
          d="M39.5 15C47.5081 15 54 21.4919 54 29.5C54 37.5081 47.5081 44 39.5 44C31.4919 44 25 37.5081 25 29.5C25 21.4919 31.4919 15 39.5 15ZM45.3838 24.9395C44.798 24.3537 43.8485 24.3538 43.2627 24.9395L37.9131 30.2881L36.0605 28.4355C35.4748 27.8498 34.5252 27.8498 33.9395 28.4355C33.3537 29.0213 33.3537 29.9709 33.9395 30.5566L36.8525 33.4707C37.4382 34.0562 38.3878 34.056 38.9736 33.4707L45.3838 27.0605C45.9694 26.4748 45.9694 25.5252 45.3838 24.9395Z"
          fill="var(--color-illustration-accent)"
          fillOpacity="0.4"
        />
      </g>
      <g filter="url(#filter2_d_693_25977)">
        <rect
          x="86"
          y="80"
          width="240"
          height="93"
          rx="5"
          fill="var(--color-illustration-card)"
        />
        <rect
          x="86.5"
          y="80.5"
          width="239"
          height="92"
          rx="4.5"
          stroke="var(--color-illustration-border)"
        />
        <rect
          x="99"
          y="98"
          width="125"
          height="5"
          rx="1.5"
          fill="var(--color-illustration-element)"
        />
        <path
          d="M99 113.5C99 112.672 99.6716 112 100.5 112H208.5C209.328 112 210 112.672 210 113.5V115.5C210 116.328 209.328 117 208.5 117H100.5C99.6716 117 99 116.328 99 115.5V113.5Z"
          fill="var(--color-illustration-element)"
        />
        <rect
          x="244"
          y="89"
          width="73"
          height="73"
          rx="5"
          fill="var(--color-illustration-secondary-element)"
        />
        <path
          d="M113.5 133C121.508 133 128 139.492 128 147.5C128 155.508 121.508 162 113.5 162C105.492 162 99 155.508 99 147.5C99 139.492 105.492 133 113.5 133ZM119.384 142.939C118.798 142.354 117.848 142.354 117.263 142.939L111.913 148.288L110.061 146.436C109.475 145.85 108.525 145.85 107.939 146.436C107.354 147.021 107.354 147.971 107.939 148.557L110.853 151.471C111.438 152.056 112.388 152.056 112.974 151.471L119.384 145.061C119.969 144.475 119.969 143.525 119.384 142.939Z"
          fill="var(--color-illustration-accent)"
          fillOpacity="0.4"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_693_25977"
          x="10"
          y="193"
          width="240"
          height="61.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.6" />
          <feComposite in2="hardAlpha" operator="out" result="offsetAlpha" />
          <feFlood
            floodColor="var(--color-illustration-border)"
            floodOpacity="1"
            result="shadowColor"
          />
          <feComposite
            in="shadowColor"
            in2="offsetAlpha"
            operator="in"
            result="shadow"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_693_25977"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_693_25977"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_693_25977"
          x="10"
          y="0"
          width="240"
          height="61.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.6" />
          <feComposite in2="hardAlpha" operator="out" result="offsetAlpha" />
          <feFlood
            floodColor="var(--color-illustration-border)"
            floodOpacity="1"
            result="shadowColor"
          />
          <feComposite
            in="shadowColor"
            in2="offsetAlpha"
            operator="in"
            result="shadow"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_693_25977"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_693_25977"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_693_25977"
          x="86"
          y="80"
          width="240"
          height="94.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.6" />
          <feComposite in2="hardAlpha" operator="out" result="offsetAlpha" />
          <feFlood
            floodColor="var(--color-illustration-border)"
            floodOpacity="1"
            result="shadowColor"
          />
          <feComposite
            in="shadowColor"
            in2="offsetAlpha"
            operator="in"
            result="shadow"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_693_25977"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_693_25977"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
